<template>
    <div>

      <z-container>
        <h3 class="text-body-1 mb-3">Extrato Cliente</h3>

          <v-card class="mb-3">
            <v-card-title class="text-subtitle-2">
              Cliente
            </v-card-title>
            <v-divider></v-divider>

            <v-card-text class="py-2">
              <v-row dense>
                <v-col sm="2">
                  <v-text-field filled dense label="Cliente Código" v-model="cliente.id" hide-details readonly></v-text-field>
                </v-col>
                <v-col sm="5">
                  <v-text-field filled dense label="Nome" v-model="cliente.razao" hide-details readonly></v-text-field>
                </v-col>
                <v-col sm="3">
                  <v-text-field filled dense label="Prazo" v-model="cliente.prazo" hide-details readonly></v-text-field>
                </v-col>
                <v-col sm="2">
                  <z-campo-valor filled dense v-model="cliente.haver" placeholder=" " label="Créditos" ref="credidos" hide-details readonly></z-campo-valor>
                </v-col>
              </v-row>
            </v-card-text>

            <v-divider></v-divider>
            
            <v-card-actions>
              <v-btn color="primary" :depressed="this.$store.state.financeiro.drawer_clientes" :outlined="!this.$store.state.financeiro.drawer_clientes" @click="SET_DRAWER_CLIENTES(true);">
                <v-icon left>mdi-magnify</v-icon>
                Clientes
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn text :disabled="$store.state.loading || !podeImprimirExtrato" @click="imprimirExtrato">
                <v-icon left>print</v-icon>
                Imprimir Extrato
              </v-btn>
            </v-card-actions>
          </v-card>

          <v-card tile :loading="$store.state.loading">
            <v-tabs :value="tab" color="primary" @change="onTabChange">
              <v-tab :key="1">Pedidos Venda</v-tab>
              <v-tab :key="2">Promissórias</v-tab>
              <v-tab :key="3">Cheques</v-tab>
              <v-tab :key="4">Recebimentos</v-tab>
              <v-tabs-slider color="primary"></v-tabs-slider>
            </v-tabs>

            <v-divider></v-divider>

            <v-tabs-items v-model="tab" touchless style="min-height: 400px;">
              <v-tab-item :key="1">
                <v-toolbar flat color="white" dense>
                  <v-btn-toggle :value="btnStatus.pedidos" mandatory @change="filtrarPedidos">
                    <v-btn value="todos" text small>
                      Todos
                    </v-btn>
                    <v-btn value="abertos" text small>
                      Em Aberto
                    </v-btn>
                    <v-btn value="pagos" text small>
                      Pagos
                    </v-btn>
                  </v-btn-toggle>

                  <v-btn icon @click="carregarExtrato" :loading="$store.state.loading">
                    <v-icon>mdi-refresh</v-icon>
                  </v-btn>
                </v-toolbar>
                
                <v-divider></v-divider>

                <v-card flat>
                  <v-card-text>
                    
                    <div class="text--primary font-weight-black">Pedidos: {{ this.pedidos.length }}</div>

                    <v-data-table 
                      id="pedidos" 
                      item-key="id" 
                      :items="pedidos"
                      :headers="headers.pedidos"
                      :loading="false"
                      :search="search.pedidos"
                      hide-default-footer
                      disable-pagination

                    >
                      <template v-slot:item="props">
                        <tr>
                          <td>{{ props.item.id }}</td>
                          <td>{{ props.item.data | dataBR}}</td>
                          <td>{{ props.item.forma_pagamento }}</td>
                          <td><v-chip class="x-small" outlined :color="corChip(props.item.situacao)">{{ props.item.situacao }}</v-chip></td>
                          <td class="text-right">{{ props.item.valor_liquido | valorBR }}</td>
                          <td class="text-right">{{ props.item.valor_restante | valorBR }}</td>
                          <td class="text-right">

                            <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                <v-btn v-on="on" icon class="ma-0" @click="imprimirPedido(props.item)">
                                  <v-icon>print</v-icon>
                                </v-btn>
                              </template>
                              <span>Imprimir Pedido</span>
                            </v-tooltip>

                          </td>
                        </tr>
                      </template>
                    </v-data-table>

                  </v-card-text>
                </v-card>
              </v-tab-item>

              <v-tab-item :key="2">

                <v-toolbar flat color="white" dense>
                  <v-btn-toggle :value="btnStatus.promissorias" mandatory @change="filtrarPromissorias">
                    <v-btn value="todos" text small>
                      Todas
                    </v-btn>
                    <v-btn value="abertos" text small>
                      Em Aberto
                    </v-btn>
                    <v-btn value="pagos" text small>
                      Pagas
                    </v-btn>
                  </v-btn-toggle>
                  
                  <v-btn icon @click="carregarExtrato" :loading="$store.state.loading">
                    <v-icon>mdi-refresh</v-icon>
                  </v-btn>
                  
                  <v-spacer></v-spacer>
                  <v-btn depressed small color="primary" @click="adicionarPromissoriaAvulsa">Nova Promissória Avulsa</v-btn>
                  <div style="width: 200px;" class="ml-5 mr-3">
                    <v-text-field v-model="search.promissorias" autofocus clearable prepend-inner-icon="search" placeholder="Documento" single-line hide-details outlined dense></v-text-field>
                  </div>

                </v-toolbar>

                <v-divider></v-divider>

                <v-card flat>
                  <v-card-title class="text-body-2  font-weight-black">
                    Promissórias: {{ this.promissorias.length }}
                  </v-card-title>
                  <v-card-text>


                    <v-data-table 
                      v-model="selected"
                      id="promissorias" 
                      item-key="id" 
                      :items="promissorias"
                      :headers="headers.promissorias"
                      :loading="false"
                      :search="search.promissorias"
                      :show-select="btnStatus.promissorias == 'abertos'"
                      hide-default-footer
                      disable-pagination
                    >
                      <template v-slot:item="props">
                        <tr :active="props.isSelected" style="cursor: pointer" @click="selecionarPromissoria(props)">
                          <td v-show="btnStatus.promissorias == 'abertos'">
                            <v-simple-checkbox :value="props.isSelected" @input="props.select(!props.isSelected)" color="primary"></v-simple-checkbox>
                          </td>
                          <td>
                            <router-link v-if="props.item.pedido_id" @click.native.stop target="_blank" :to="{ name: 'PedidosEditar', params: { id: props.item.pedido_id }}">{{ props.item.documento }}</router-link>
                            <span v-else>{{ props.item.documento }}</span>
                          </td>
                          <td>{{ props.item.forma_pagamento}}</td>
                          <td>{{ props.item.vencimento | dataBR}}</td>
                          <td class="text-right">{{ props.item.valor | valorBR}}</td>
                          <td class="text-right">{{ props.item.valor_pago | valorBR}}</td>
                          <td class="text-right"><b>{{ props.item.valor_restante | valorBR}}</b></td>
                          <td :title="props.item.observacoes">{{ props.item.observacoes}}</td>
                          <td class="text-center" style="white-space: nowrap">
                            <v-tooltip top v-if="!props.item.pedido_id && props.item.valor_pago == 0">
                              <template v-slot:activator="{ on }" v-if="!props.item.pedido_id">
                                <v-btn v-on="on" icon class="ma-0" @click.stop="excluir(props.item)">
                                  <v-icon>delete</v-icon>
                                </v-btn>
                              </template>
                              <span>Excluir</span>
                            </v-tooltip>
                            <v-tooltip top v-if="props.item.valor_pago > 0">
                              <template v-slot:activator="{ on }">
                                <v-btn v-on="on" icon class="ma-0" @click.stop="exibirPagamentos(props.item)">
                                  <v-icon>mdi-eye</v-icon>
                                </v-btn>
                              </template>
                              <span>Visualizar Pagamentos</span>
                            </v-tooltip>
                          </td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-card-text>
                </v-card>
              </v-tab-item>

              <v-tab-item :key="3">
                <v-toolbar flat color="white" dense>
                  <v-btn-toggle :value="btnStatus.cheques" mandatory @change="filtrarCheques">
                    <v-btn value="todos" text small>
                      Todos
                    </v-btn>
                    <v-btn value="emcaixa" text small>
                      Em Caixa
                    </v-btn>
                    <v-btn value="compensado" text small>
                      Compensados
                    </v-btn>
                    <v-btn value="repassados" text small>
                      Repassados
                    </v-btn>
                    <v-btn value="devolvidos" text small>
                      Devolvidos
                    </v-btn>
                  </v-btn-toggle>

                  <v-btn icon @click="carregarExtrato" :loading="$store.state.loading">
                    <v-icon>mdi-refresh</v-icon>
                  </v-btn>

                </v-toolbar>

                <v-divider></v-divider>

                <v-card flat>
                  <v-card-text>

                    <div class="text--primary font-weight-black">Cheques: {{ this.cheques.length }}</div>

                  <v-data-table 
                    item-key="id" 
                    :headers="headers.cheques"
                    :items="cheques" 
                    :loading="false" 
                    :search="search.cheques" 
                  >
                    <template v-slot:item="props">
                      <tr>
                        <td>{{ props.item.numero }}</td>
                        <td>{{ props.item.vencimento | dataBR}}</td>
                        <td>{{ props.item.emitente }}</td>
                        <td class="text-right">{{ props.item.valor | valorBR }}</td>
                        <td><v-chip class="x-small" outlined :color="corChipCheque(props.item.status)">{{ props.item.status }}</v-chip></td>
                        <td class="text-center">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-btn v-on="on" icon class="ma-0">
                                <v-icon>visibility</v-icon>
                              </v-btn>
                            </template>
                            <span>Visualizar Cheque</span>
                          </v-tooltip>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>

                  </v-card-text>
                </v-card>

              </v-tab-item>

              <v-tab-item :key="4">
                <v-toolbar flat color="white" dense>
                  <div style="width: 200px;">
                    <v-text-field v-model="search.recebimentos" autofocus clearable prepend-inner-icon="search" placeholder="Número do Recibo" single-line hide-details outlined dense></v-text-field>
                  </div>

                  <v-btn icon @click="carregarExtrato" :loading="$store.state.loading">
                    <v-icon>mdi-refresh</v-icon>
                  </v-btn>
                </v-toolbar>

                <v-divider></v-divider>
                
                <v-alert icon="mdi-information" class="my-3 mx-5" color="grey" outlined text>
                  Clique no recebimento abaixo para visualizar os documentos recebidos.
                </v-alert>
                
                <v-divider></v-divider>

                <v-card flat>
                  <v-card-text>

                    <div class="text--primary font-weight-black">Recbimentos: {{ this.recebimentos.length }}</div>

                    <v-data-table 
                      ref="recebimentos" 
                      :headers="headers.recebimentos" 
                      :items="recebimentos" 
                      :search="search.recebimentos" 
                      :loading="false"   
                      :single-expand="true"
                    >
                      <template v-slot:item="props">
                        <tr :active="props.item.id == selecionado.id" @click.stop="selecionar(props.item); props.expand(!props.isExpanded)" style="cursor: pointer">
                          <td>
                            <v-btn icon small class="expanded-icon">
                              <v-icon v-show="props.isExpanded">mdi-chevron-up</v-icon>
                              <v-icon v-show="!props.isExpanded">mdi-chevron-down</v-icon>
                            </v-btn>
                          </td>
                          <td>{{ props.item.id }}</td>
                          <td>{{ props.item.data | dataBR }}</td>
                          <td class="text-right">{{ props.item.total | valorBR }}</td>
                          <td class="text-center">{{ props.item.qtd_documentos }}</td>
                          <td class="text-right" style="white-space: nowrap">
                            <v-btn icon @click.stop="imprimirRecibo(props.item.id)" class="ma-0">
                              <v-icon>print</v-icon>
                            </v-btn>
                            <v-btn icon @click.stop="perguntarCancelarRecebimento(props.item)" class="ma-0">
                              <v-icon>delete</v-icon>
                            </v-btn>
                          </td>
                        </tr>
                      </template>

                      <template v-slot:expanded-item="{ item }">
                        <tr>
                          <td colspan="6" class="px-0">
                            <v-card>
                              <v-card-text class="px-0">
                                
                                <v-card tile flat>
                                  <v-tabs v-model="tab_recebimentos" color="primary" background-color="primary" dark>
                                    <v-tab :key="0">Documentos Pagos</v-tab>
                                    <v-tab :key="1">Formas de Pagamento</v-tab>
                                  </v-tabs>
                                  
                                  <v-tabs-slider color="white"></v-tabs-slider>
                                  
                                  <v-divider></v-divider>

                                  <v-tabs-items v-model="tab_recebimentos" touchless>
                                    <v-tab-item :key="0">
                                      <v-data-table ref="documentos" no-data-text="Carregando..." :headers="headers.documentos" :items="documentos" :loading="loadingdocs" hide-default-footer>
                                        <v-progress-linear slot="progress" color="primary" height="2" indeterminate></v-progress-linear>
                                        <template v-slot:item="props">
                                          <tr>
                                            <td>{{ props.item.documento }}</td>
                                            <td class="text-center">{{ props.item.contareceber.vencimento | dataBR }}</td>
                                            <td class="text-right">{{ props.item.valor_original | valorBR }}</td>
                                            <td class="text-right font-weight-bold">{{ props.item.valor_pago | valorBR }}</td>
                                            <td class="text-right">{{ props.item.valor_restante | valorBR }}</td>
                                            <td class="text-center">
                                              <v-tooltip bottom v-show="props.item.valor_pago > 0">
                                                <template v-slot:activator="{ on }">
                                                  <v-btn v-on="on" icon class="ma-0" @click.stop="exibirPagamentos(props.item)">
                                                    <v-icon>visibility</v-icon>
                                                  </v-btn>
                                                </template>
                                                <span>Histórico de Pagamentos</span>
                                              </v-tooltip>
                                            </td>
                                          </tr>
                                        </template>
                                        <template v-slot:body.append="{ headers }">
                                          <tr>
                                            <td colspan="4" class="text-right font-weight-bold">
                                              {{ total_documentos | valorBR }}
                                            </td>
                                            <td colspan="2"></td>
                                          </tr>
                                        </template>
                                      </v-data-table>
                                    </v-tab-item>

                                    <v-tab-item :key="1">
                                      <v-data-table ref="valores" :headers="headers.valores" :items="valores" :loading="loadingdocs" hide-default-footer>
                                        <v-progress-linear slot="progress" color="primary" height="2" indeterminate></v-progress-linear>
                                        <template v-slot:item="props">
                                          <tr>
                                            <td>{{ props.item.forma_pagamento }}</td>
                                            <td class="text-right">{{ props.item.valor | valorBR }}</td>
                                          </tr>
                                        </template>
                                      </v-data-table>
                                    </v-tab-item>
                                  </v-tabs-items>
                                  
                                </v-card>

                              </v-card-text>
                            </v-card>
                          </td>
                        </tr>
                      </template>

                    </v-data-table>

                  </v-card-text>
                </v-card>

              </v-tab-item>
            </v-tabs-items>
            
          </v-card>
      </z-container>

      <z-dialogo ref="dialogoCancelarRecebimento" titulo="Deseja realmente cancelar esse recebimento?" :dividers="true" largura="500px">
        <div slot="texto">
          <v-list>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle>Data</v-list-item-subtitle>
                <v-list-item-title>{{ recebimento.data | dataBR}}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle>Documentos</v-list-item-subtitle>
                <v-list-item-title>{{ recebimento.qtd_documentos }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle>Valor Recebido</v-list-item-subtitle>
                <v-list-item-title>{{ recebimento.total | valorBR }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        
        </div>

        <v-btn text @click="$refs.dialogoCancelarRecebimento.fechar()" :disabled="cancelando">Cancelar</v-btn>
        <v-btn color="red darken-1" text @click="confirmarCancelarRecebimento" :loading="cancelando" :disabled="cancelando">Confirmar</v-btn>
      </z-dialogo>

      <z-dialogo-sim-nao ref="dialogoCancelarRecebimento2" titulo="Remover recebimento?" botaoSim="Remover" botaoNao="Cancelar">
        O recebimento <b>{{recebimento.id}}</b> no valor de <b>R$ {{recebimento.total | valorBR}}</b> com <b>{{recebimento.qtd_documentos}}</b> documento(s) será removido.
      </z-dialogo-sim-nao>

      <z-dialogo-sim-nao ref="dialogoRemoverPromissoria" titulo="Remover promissória?" botaoSim="Remover" botaoNao="Cancelar">
        A promissória será removida.
      </z-dialogo-sim-nao>

      <z-dialogo 
        ref="dialogoPromissoria" 
        titulo="Nova Promissória" 
        largura="750px" 
        eager
        :dividers="true" 
      >
        <template v-slot:texto>

          <v-form ref="form_promissoria" v-model="form_valido" lazy-validation>

              <v-row dense>
                <v-col sm="3">
                  <v-text-field ref="documento" v-model="promissoria.documento" placeholder=" " label="Documento" :rules="regras.documento" autofocus filled dense></v-text-field>
                </v-col>
                <v-col sm="3">
                  <v-select v-model="promissoria.forma_pagamento" label="Forma de Pagamento" :items="$globals.FORMAS_DE_PAGAMENTO" filled dense></v-select>
                </v-col>
                <v-col sm="3">
                  <z-date-picker-menu v-model="promissoria.vencimento" placeholder=" " label="Vencimento" filled dense></z-date-picker-menu>
                </v-col>
                <v-col sm="3">
                  <z-campo-valor v-model="promissoria.valor" placeholder=" " label="Valor" :rules="regras.valor" ref="valor" filled dense></z-campo-valor>
                </v-col>
              </v-row>

              <v-row dense>
                <v-col sm="12">
                  <v-textarea label="Observações" placeholder="Observações" v-model="promissoria.observacoes" filled dense></v-textarea>
                </v-col>
              </v-row>
              
          </v-form>

        </template>

        <v-btn text @click="$refs.dialogoPromissoria.fechar()" :disabled="salvando">Cancelar</v-btn>
        <v-btn color="primary" depressed @click="confirmarPromissoria" :loading="salvando" :disabled="salvando || !form_valido">Adicionar</v-btn>

      </z-dialogo>

      <historico-pagamento ref="dialogoExibirPagamentos"></historico-pagamento>

      <!-- <v-container> -->
        
      <v-slide-y-reverse-transition>
        <v-card class="elevation-10" width="300px" style="position: fixed; right: 10px; bottom: 10px;" v-show="selected.length > 0 && tab == 1">
          <v-card-title class="" :style="[styleCardTotal]">
            <div class="white--text">
              <div><b>Total Selecionado ({{ selected.length }})</b></div>
              <h3 class="headline mb-0">R$ {{ selected.reduce((soma, sel) => soma + sel.valor_restante, 0) | valorBR}}</h3>
            </div>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-actions color="white" class="d-flex flex-row justify-space-between">
            <v-btn depressed color="primary" class="flex-grow-1" @click="receber">Receber</v-btn>
            <v-btn text color="grey" class="flex-grow-1" @click="cancelarSelecionados">Cancelar</v-btn>
          </v-card-actions>
        </v-card>
      </v-slide-y-reverse-transition>
      <!-- </v-container> -->

    </div>
</template>

<script>
import { mapMutations, mapActions, mapState } from "vuex";
import HistoricoPagamento from "./HistoricoPagamento";
import config from '@/app/config';
import * as types from '@/app/store/mutation_types';

const TAB_PEDIDOS = 0;
const TAB_PROMISSORIAS = 1;
const TAB_CHEQUES = 2;
const TAB_RECEBIMENTOS = 3;

export default {
  name: 'extrato-cliente',

  components: {
    HistoricoPagamento
  },

  data() {
    return {
      cliente_id: null,
      // cliente: {},
      search: {
        pedidos: '',
        promissorias: '',
        cheques: ''
      },
      headers: {
        pedidos: [
          { text: 'Pedido', value: 'id', width: '80px' },
          { text: 'Data', value: 'data', width: '100px' },
          { text: 'Forma Pagamento', value: 'forma_pagamento', width: '150px' },
          { text: 'Situação', value: 'situacao', width: '110px' },
          { text: 'Valor Total', value: 'valor_liquido', align: 'right', width: '130px' },
          { text: 'Valor Restante', value: 'valor_restante', align: 'right', width: '130px' },
          { text: 'Opções', value:'', width: '180px', align: 'right', sortable: false }
        ],
        promissorias: [
          { text: 'Documento', value: 'documento', width: '100px'},
          { text: 'Tipo', value: 'forma_pagamento' , width: '150px'},
          { text: 'Vencimento', value: 'vencimento', width: '100px'},
          { text: 'Valor', value: 'valor', align: 'right', width: '100px'},
          { text: 'Valor Pago', value: 'valor_pago', align: 'right', width: '100px'},
          { text: 'Restante', value: 'valor_restante', align: 'right', width: '100px'},
          { text: 'Observações', value: 'observacoes', width: '100px' },
          { text: 'Opções', value:'', width: '80px', align: 'center', sortable: false }
        ],
        cheques: [
          { text: 'Número', value: 'numero', width: '150px' },
          { text: 'Vencimento', value: 'data' },
          { text: 'Emitente', value: 'emitente' },
          { text: 'Valor', value: 'valor', align: 'right' },
          { text: 'Situação', value: 'status' },
          { text: 'Opções', value: '', width: '200px', align: 'center', sortable: false }
        ],
        recebimentos: [
          { text: '', value: '', sortable: false, width: '50px'},
          { text: 'Número', value: 'id', sortable: false},
          { text: 'Data', value: 'data', sortable: false},
          { text: 'Total', value: 'total', align: 'right', sortable: false },
          { text: 'Docs', value: 'documentos', align: 'center', sortable: false },
          { text: 'Opções', value: '', align: 'right', sortable: false }
        ],
        documentos: [
          { text: 'Documento', value: 'documento', sortable: false },
          { text: 'Vencimento', value: 'vencimento', align: 'center', sortable: false },
          { text: 'Valor Original', value: 'valor_original', align: 'right', sortable: false },
          { text: 'Valor Pago', value: 'valor_pago', align: 'right', sortable: false },
          { text: 'Valor Restante', value: 'valor_restante', align: 'right', sortable: false },
          { text: 'Histórico', value: '', align: 'center', sortable: false }
        ],
        valores: [
          { text: 'Forma de Pagamento', value: 'forma_pagamento', sortable: false },
          { text: 'Valor', value: 'valor', align: 'right', sortable: false },
        ]
      },
      // btnStatus: {
      //   pedidos: 'abertos',
      //   promissorias: 'abertos',
      //   cheques: 'emcaixa'
      // },
      // tab: null,
      tab_recebimentos: 0,
      loading: false,
      loadingdocs: false,
      cancelando: false,
      salvando: false,
      selected: [],
      selecionado: {},
      recebimento: {},
      promissoria: {
        cliente_id: null,
        documento: '',
        forma_pagamento: '',
        vencimento: '',
        valor: '',
        valor_pago: '',
        valor_restante: '',
        observacao: ''
      },
      form_valido: true,
      regras: {
        documento: [v => !!v || 'Documento é obrigatório'],
        valor: [v => v != '0,00'   || 'Valor é obrigatório']
      },
    }
  },

  inject: ['$imprimir'],

  computed: {
    ...mapState('financeiro', ['pedidos', 'promissorias', 'cheques', 'recebimentos', 'documentos', 'valores', 'cliente_selecionado', 'btnStatus', 'tab']),
    ...mapState('clientes', {
        cliente: 'cliente'
    }),

    podeImprimirExtrato() {
      return this.promissorias.length > 0 || this.pedidos.length > 0 || this.cheques.length > 0
    },

    total_documentos() {
      if (!this.documentos) {
        return 0;
      }
      
      return this.documentos.reduce((soma, documento) => { return soma + documento.valor_pago }, 0)
    },

    styleCardTotal() {
      return {
        'background-color': this.$vuetify.theme.themes.light.primary
      }
    }
    
  },

  beforeRouteLeave(to, from, next) {
    if (to.name != 'RecebimentoPromissorias') {
      this.limparlistas();
      this.abrirCliente({});
      this.SET_DRAWER_CLIENTES(false);
      this.$store.commit('clientes/SET_BUSCA', '');
    }

    next();
  },

  mounted() {
    console.log(this.cliente);
    this.setTitulo('Extrato do Cliente');
    this.$store.dispatch('listas/clientes');
    this.SET_DRAWER_CLIENTES(true);

    this.tab_recebimentos = 0;
    if (this.cliente.id) {
      // this.cliente.id = this.cliente.id;
      // this.tab = 1;
      this.btnStatus.promissorias = 'abertos';
    } else {
      // this.limparlistas();
    }

    // this.tab = 1;
    // this.btnStatus.promissorias = 'abertos';
  },

  methods: {
    ...mapMutations(['setTitulo', 'LOADING_OFF']),
    
    ...mapMutations('recebimentos', ['limparPromissorias', 'adicionarPromissoria']),
    ...mapActions('recebimentos', ['setCliente']),
    ...mapActions({
        abrirCliente: 'clientes/abrir'
      }),

    ...mapMutations('financeiro', ['limparlistas', types.SET_DRAWER_CLIENTES]),
    ...mapActions('financeiro', ['extratocliente', 'recebimentoDocumentos', 'cancelarRecebimento', 'excluirPromissoria']),

    async onTabChange(tab) {
      this.$store.commit('financeiro/SET_TAB', tab);

      
      if (this.tab == TAB_PEDIDOS && this.pedidos.length > 0) {
        return false;
      }
      
      if (this.tab == TAB_PROMISSORIAS && this.promissorias.length > 0) {
        return false;
      }

      if (this.tab == TAB_CHEQUES && this.cheques.length > 0) {
        return false;
      }

      if (this.tab == TAB_RECEBIMENTOS && this.recebimentos.length > 0) {
        return false;
      }

      await this.carregarExtrato();
    },

    async carregarExtrato() {
      try {

        await this.$store.dispatch('financeiro/extratocliente');

      } catch (error) {
        this.$eventbus.erro('Não foi possível carregar o extrato.', error)
      } finally {
        this.loading = false;
      }
    },

    async filtrarPedidos(status) {
      this.$store.commit('financeiro/SET_BTNGROUPS', {
        btn: 'pedidos', 
        status: status
      });

      this.carregarExtrato();
    },

    async filtrarPromissorias(status) {
      this.$store.commit('financeiro/SET_BTNGROUPS', {
        btn: 'promissorias', 
        status: status
      });

      this.carregarExtrato();
    },

    async filtrarCheques(status) {
      this.$store.commit('financeiro/SET_BTNGROUPS', {
        btn: 'cheques', 
        status: status
      });

      this.carregarExtrato();
    },

    async filtrarRecebimentos(status) {
      this.$store.commit('financeiro/SET_BTNGROUPS', {
        btn: 'recebimentos', 
        status: status
      });

      this.carregarExtrato();
    },

    async filtrar() {
      try {
        this.loading = true;
        await this.extratocliente(this.cliente.id);
        this.tab = 1;
        this.btnStatus.promissorias = 'abertos';
        if (this.recebimentos.length > 0) {
          this.selecionado = this.recebimentos[0];
          await this.recebimentoDocumentos(this.selecionado.id);
        }
      } catch (error) {
        this.$eventbus.erro('Não foi possível carregar o extrato do cliente', error)
      } finally {
        this.loading = false;
      }
      
    },

    receber(promissoria){
      if (this.selected.length > 0) {
        this.selected.forEach(selected => {
          this.adicionarPromissoria(this.clone(selected));
        })
      } else {
        this.adicionarPromissoria(this.clone(promissoria));
      }

      this.abrirCliente(this.cliente.id);
      this.$router.push('/financeiro/extratocliente/recebimento');
    },

    cancelarSelecionados() {
      this.selected = [];
    },

    adicionarPromissoriaAvulsa() {
      this.$refs.form_promissoria.resetValidation();
      this.promissoria = {
        cliente_id: this.cliente.id,
        documento: '',
        forma_pagamento: 'Duplicata',
        vencimento: this.hoje(),
        valor: 0,
        observacao: ''
      },
      this.$refs.dialogoPromissoria.abrir();
      this.setFocus('documento');
    },

    async confirmarPromissoria() {
      try {
        this.salvando = true;
        this.promissoria.valor_restante = this.promissoria.valor;
        await this.$store.dispatch('financeiro/adicionarPromissoria', this.promissoria);
        this.$eventbus.notificar('Promissória salva com sucesso');
        this.$refs.dialogoPromissoria.fechar();
      } catch (error) {
        this.$eventbus.erro('Não foi possível salvar promissória', error);
      } finally {
        this.salvando = false;
      }
    },

    imprimirPedido(pedido) {
      this.$imprimir(`/pedidos/${pedido.id}/imprimir`, `pedido_${pedido.id}.pdf`);
      // this.abrirJanela(config.BASE_URL_PRINT + '/pedidos/'+ pedido.id +'/imprimir');
    },

    abrirPedido(promissoria) {
      this.abrirJanela(config.BASE_URL + '/#/vendas/pedidos/'+ promissoria.pedido_id +'/editar');
    },

    async onChangeCliente(cliente) {
      await this.abrirCliente(this.cliente.id);
      this.selected = [];
      this.limparlistas();
      this.filtrar();
    },

    corChip(situacao) {
      switch (situacao) {
          case 'Orçamento':
              return 'primary'
              break;

          case 'Pedido':
              return 'red'
              break;

          case 'Cancelado':
              return 'red'
              break;

          case 'Faturado':
              return 'green'
              break;

          default:
              break;
      }
    },

    corChipCheque(situacao) {
      switch (situacao) {
          case 'Em Caixa':
              return 'green'
              break;

          case 'Compensado':
              return 'blue'
              break;

          case 'Devolvido':
              return 'red'
              break;

          case 'Repassado':
              return 'orange'
              break;

          default:
              break;
      }
    },

    async selecionar(recebimento) {
      if (this.selecionado.id != recebimento.id) {
        this.loadingdocs = true;
        this.selecionado = recebimento;
        await this.recebimentoDocumentos(recebimento.id);
        this.tab_recebimentos = 0;
        this.loadingdocs = false;
      }
    },

    selecionarPromissoria(props) {
      if (this.btnStatus.promissorias == 'abertos') {
        props.select(!props.isSelected)
      }
    },

    exibirPagamentos(documento) {
      this.$refs.dialogoExibirPagamentos.abrir(documento);
    },

    imprimirRecibo(recebimento_id) {
      this.$imprimir(`/financeiro/${recebimento_id}/recibo`, `recibo_${recebimento_id}.pdf`);
    },

    imprimirExtrato() {
      this.$imprimir(`financeiro/${this.cliente.id}/extratocliente`, `extrato_cliente_${this.cliente.razao}.pdf`);
    },
    
    async perguntarCancelarRecebimento(recebimento) {
      // this.cancelando = true;
      this.recebimento = recebimento;
      let response = await this.$refs.dialogoCancelarRecebimento2.abrir();
      if (response == true) {
        this.confirmarCancelarRecebimento();
      }
    },

    async confirmarCancelarRecebimento() {
      
      try {
        this.cancelando = true;
        await this.cancelarRecebimento(this.recebimento.id);
        // this.selecionado = this.recebimentos[0];
        // await this.recebimentoDocumentos(this.selecionado.id);
        this.$eventbus.notificar('Recebimento cancelado');
      } catch (error) {
        console.log(error);
        this.$eventbus.erro('Não foi possível cancelar o recebimento', error);
      } finally {
        this.cancelando = false;
        this.$refs.dialogoCancelarRecebimento2.fechar();
        await this.extratocliente(this.cliente.id);
      }

      
    },

    async excluir(promissoria) {
      this.$refs.dialogoRemoverPromissoria.abrir()
        .then(async response => {

          if (response == true) {

            try {
              this.$refs.dialogoRemoverPromissoria.startLoading();
              await this.excluirPromissoria(promissoria.id);
              this.$refs.dialogoRemoverPromissoria.fechar();
              this.$eventbus.notificar('Promissória excluída com sucesso');
            } catch (error) {
              this.$eventbus.erro('Não foi possível excluir promissória', error);
            } finally {
              this.$refs.dialogoRemoverPromissoria.stopLoading();
            }

          }

        })


    }
  },

  watch: {
    cliente(val, oldval) {
      if (val.id != oldval.id) {
        this.selected = [];
      }
    }
  }
};
</script>

<style scoped>

</style>

